//Common Styles
import {
  SectionHeader,
  SectionTitle,
  WorkspacePanel,
  WorkspaceSection,
  WorkSpaceTitleRow,
  CustomerInstructionsContainer,
  CustomerInstructionsContent,
  CustomerInstructionsEmpty,
  CustomerInstructionsEmptyIcon,
} from "../../styles/commonStyles";

//Icons
import { InfoIcon } from "../Svg";

//Types
type CustomerInstructionsProps = {
  record: any;
  showMeta?: boolean;
  maxLength?: number;
};

const CustomerInstructions = ({ 
  record,
}: CustomerInstructionsProps) => {

  const hasInstructions = Boolean(record?.customerNotes && record.customerNotes.trim());

  return (
    <WorkspacePanel>
      <WorkspaceSection>
        <SectionHeader>
          <WorkSpaceTitleRow>
            <InfoIcon height={18} width={18} />
            <SectionTitle>Customer Instructions</SectionTitle>
          </WorkSpaceTitleRow>
        </SectionHeader>
      </WorkspaceSection>

      <CustomerInstructionsContainer>

        {hasInstructions ? (
          <CustomerInstructionsContent hasContent={true}>
            {record.customerNotes}
          </CustomerInstructionsContent>
        ) : (
          <CustomerInstructionsEmpty>
            <CustomerInstructionsEmptyIcon>📝</CustomerInstructionsEmptyIcon>
            <span>No customer instructions provided</span>
          </CustomerInstructionsEmpty>
        )}
      </CustomerInstructionsContainer>
    </WorkspacePanel>
  );
};

export default CustomerInstructions;
